<template>
	<footer class="footer" :style="cssVars">
		<div class="upper container">
			<div class="inner">
				<a href="/" class="brand"
					><img
						:src="
							parsedGlobalSettings.footer.footer_logo
								? parsedGlobalSettings.footer.footer_logo.url
								: this.logo
						"
						alt="FEP"
						height="50"
				/></a>

				<h2>Shaping the future of production solutions</h2>
			</div>
		</div>

		<div class="lower container">
			<div class="inner">
				<div class="footer_col one">
					<ul>
						<li v-for="(footer_link, index) in parsedFooterMenu" :key="index">
							<a :href="footer_link.url" :target="footer_link.target">
								<span v-html="footer_link.title"></span>
							</a>
						</li>
					</ul>
				</div>

				<div class="footer_col two">
					<!-- Empty -->
				</div>

				<div class="footer_col three">
					<div
						class="aoc"
						v-if="parsedGlobalSettings.general.aoc"
						v-html="parsedGlobalSettings.general.aoc"
					></div>

					<ul>
						<li
							v-for="(footer_link, index) in parsedFooterMenuTwo"
							:key="index"
						>
							<a :href="footer_link.url" :target="footer_link.target">
								<span v-html="footer_link.title"></span>
							</a>
						</li>
					</ul>

					<span class="copyright"
						>&copy; Food Processing Equipment {{ getTheYear }}</span
					>
				</div>

				<div class="footer_col four">
					<div
						class="contact_location"
						v-html="parsedGlobalSettings.footer.contact_location"
					></div>

					<ul class="socials">
						<li>
							<a
								:href="parsedGlobalSettings.footer.email"
								:target="parsedGlobalSettings.footer.email_icon"
							>
								<img
									:src="parsedGlobalSettings.footer.email_icon.url"
									:alt="parsedGlobalSettings.footer.email"
								/>
							</a>
						</li>
					</ul>

					<ul
						v-if="parsedGlobalSettings.footer.social_channels"
						class="socials"
					>
						<template
							v-for="(channel, index) in parsedGlobalSettings.footer
								.social_channels"
						>
							<li v-if="channel.url != false" :key="index">
								<a :href="channel.url.url" :target="channel.url.target"
									><img
										v-if="channel.icon != false"
										:src="channel.icon.url"
										:alt="index"
								/></a>
							</li>
						</template>
					</ul>
				</div>
			</div>
		</div>

		<div class="footer_bottom">
			<div class="container">
				<div class="inner">
					<a
						:href="parsedGlobalSettings.general.built_by.url"
						target="_blank"
						v-html="parsedGlobalSettings.general.built_by.title"
					></a>
				</div>
			</div>
		</div>
	</footer>
</template>

<script>
export default {
	data() {
		return {
			window: {
				width: 0,
				height: 0,
			},
		};
	},

	props: {
		logo: {},
		footer_menu: {},
		footer_menu_two: {},
		footer_nav_bottom: {},
		current_id: {
			type: Number,
			default: -1,
		},
		global_settings: {},
		asset_url: {},
		built_by: {},
		privacy_policy: {},
	},

	computed: {
		parsedGlobalSettings() {
			if (this.global_settings) {
				return JSON.parse(this.global_settings);
			} else {
				return null;
			}
		},

		parsedFooterMenu() {
			if (this.footer_menu) {
				return JSON.parse(this.footer_menu);
			} else {
				return null;
			}
		},

		parsedFooterMenuTwo() {
			if (this.footer_menu_two) {
				return JSON.parse(this.footer_menu_two);
			} else {
				return null;
			}
		},

		parsedFooterBottom() {
			if (this.footer_nav_bottom) {
				return JSON.parse(this.footer_nav_bottom);
			} else {
				return null;
			}
		},

		getTheYear() {
			var d = new Date();
			var n = d.getFullYear();
			return n;
		},

		cssVars() {
			return {
				'--spacer': '24px',
				'--spacer-mobile': '16px',
				'--gutter-mobile': '24px',
				'--gutter-tablet-desktop': '24px',
				'--body-font-size': '16px/22px',
				'--max-width': '1440px',
			};
		},
	},

	watch: {},

	methods: {
		getFullUrl(arg) {
			let assetUrl = this.asset_url;
			return assetUrl + arg + '.svg';
		},

		handleResize() {
			this.window.width = window.innerWidth;
			this.window.height = window.innerHeight;
		},
	},

	components: {},

	created() {
		window.addEventListener('resize', this.handleResize);
		window.addEventListener('load', this.handleResize);
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},

	destroyed() {
		window.removeEventListener('resize', this.handleResize);
		this.handleResize();
	},

	mounted() {
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},

	change() {
		window.dispatchEvent(new Event('resize'));
		this.handleResize();
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.footer {
	padding: 40px 0;
	background: var(--fpe-light-grey);
	/* border-top: var(--border); */
	overflow: hidden;

	@media (max-width: $mobile-xl) {
		padding: 32px 0;
	}

	.upper {
		@media (max-width: $mobile-xl) {
			row-gap: 24px;
			margin-bottom: 0;
		}

		&.container {
			column-gap: 24px;

			.inner {
				grid-column: span 12;
				display: grid;
				grid-template-columns: repeat(12, 1fr);
				column-gap: 24px;
				border-top: 1px solid var(--white);
				padding-top: 32px;
				border-bottom: 1px solid var(--white);

				@media (max-width: $mobile-xl) {
					grid-template-columns: repeat(4, 1fr);
					grid-column: span 4;
					padding-bottom: 32px;
				}

				.brand {
					grid-column: span 3;
					display: flex;
					margin-bottom: 32px;

					@media (max-width: $mobile-xl) {
						grid-column: span 4;
						justify-content: center;
					}

					img {
						height: 36px;

						@media (max-width: $mobile-xl) {
							height: 36px;
							padding: 0 0;
						}
					}
				}

				h2 {
					grid-column: 7 / span 6;
					color: var(--fpe-blue);
					margin: 0;
					font-family: var(--primary-font-family-heading);

					@media (max-width: $mobile-xl) {
						grid-column: span 4;
						text-align: center;
					}
				}
			}
		}
	}

	.lower {
		margin-top: 0;
		padding-top: 40px;

		@media (max-width: $mobile-xl) {
			margin-top: 0;
			padding-top: 0;
		}

		.container {
			height: unset;
		}

		.inner {
			grid-column: span 12;
			display: grid;
			grid-template-columns: repeat(12, 1fr);
			gap: 24px;
			/* border-top: var(--border-bright);
			padding-top: 16px; */

			@media (max-width: $mobile-xl) {
				grid-template-columns: repeat(4, 1fr);
				grid-column: span 4;
				/* display: flex;
        flex-wrap: wrap;
        gap: 24px;
        align-items: center; */
				padding-top: 24px;
				justify-content: center;
			}

			.footer_col {
				grid-column: span 3;
				color: var(--white);

				@media (max-width: $mobile-xl) {
					grid-column: span 4;
					padding: 0 var(--gutter-tablet-desktop);
					/* border-top: var(--border-bright); */

					&:last-of-type {
						padding-bottom: 16px !important;
					}
				}

				&.one {
					grid-column: span 3;
					/* grid-column: span 5;

				@media (max-width: $mobile-xl) {
					grid-column: span 4;
					margin-bottom: 0;
				} */

					&::v-deep {
						h5 {
							margin: 0;
						}
					}

					@media (max-width: $mobile-xl) {
						grid-column: 1 / span 4;
						padding: 0 0 0;
						order: 0;
						border-top: 0;
					}

					ul {
						list-style: none;
						padding: 0;
						display: flex;
						flex-direction: column;
						flex-wrap: wrap;
						gap: 20px;

						@media (max-width: $mobile-xl) {
							display: grid;
							grid-template-columns: 1fr;
						}

						li {
							border-bottom: 1px solid var(--fpe-blue);
							padding-bottom: 5px;

							&:hover {
								border-bottom: 1px solid var(--fpe-light-brown);
								transition: 0.2s ease all;
							}

							a {
								padding: 0;
								border-right: 0;
								border: none;
								position: relative;
								display: flex;
								align-items: center;
								gap: 12px;
								text-transform: uppercase;
								color: var(--fpe-blue);
								text-decoration: none;
								position: relative;
								overflow: hidden;
								font: normal normal 300 14px/18px var(--primary-font-family);

								span {
									transition: 0.2s ease all;
									font: normal normal 300 14px/18px var(--primary-font-family);
									position: relative;
									left: 0;
								}

								@media (max-width: $mobile-xl) {
									overflow: hidden;
									text-overflow: ellipsis;
									white-space: nowrap;
								}

								&:hover {
									span {
										position: relative;
										left: -21px;
										transition: 0.2s ease all;
										color: var(--fpe-light-brown);
									}

									&::before {
										opacity: 0;
										transition: 0.2s ease all;
										transform: translateX(-100%);
										visibility: hidden;
									}

									&::after {
										opacity: 1;
										transition: 0.2s ease all;
										transform: translateX(-21px);
										visibility: visible;
									}
								}

								&::before {
									content: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxMCAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuODM0Njk3IDEwTDAgOS4xNzg5OEw2Ljg1NzYxIDIuMjgyNDNMMi4zMDc2OSAxLjIxNTExTDIuNTY5NTYgMEw4LjUxMDY0IDEuNDYxNDFMMTAgNy41MDQxMUw4Ljc3MjUgNy43ODMyNUw3LjY5MjMxIDMuMTE5ODdMMC44MzQ2OTcgMTBaIiBmaWxsPSIjNTM2MjhCIi8+Cjwvc3ZnPgo=');
									/* width: 6.11px;
                height: 6.09px;
                background: var(--cobalt); */
									opacity: 1;
									transition: 0.2s ease all;
									transform: translateX(0);
									visibility: visible;
								}

								&::after {
									content: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxMCAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuODM0Njk3IDEwTDAgOS4xNzg5OEw2Ljg1NzYxIDIuMjgyNDNMMi4zMDc2OSAxLjIxNTExTDIuNTY5NTYgMEw4LjUxMDY0IDEuNDYxNDFMMTAgNy41MDQxMUw4Ljc3MjUgNy43ODMyNUw3LjY5MjMxIDMuMTE5ODdMMC44MzQ2OTcgMTBaIiBmaWxsPSIjOWQ4ODc5Ii8+Cjwvc3ZnPgo=');
									/* width: 6.11px;
                height: 6.09px;
                background: var(--cobalt); */
									opacity: 0;
									transition: 0.2s ease all;
									transform: translateX(0);
									visibility: hidden;
								}
							}
						}
					}
				}

				&.two {
					grid-column: span 3;

					@media (max-width: $mobile-xl) {
						grid-column: 1 / span 4;
						display: none;
					}
				}

				&.three {
					grid-column: span 3;

					@media (max-width: $mobile-xl) {
						grid-column: span 4;
						padding: 0;
						justify-content: flex-start;
						flex-direction: column;
						grid-template-columns: 1fr;
						padding-top: 0;
						padding-bottom: 0;
						order: 3;
						/* border-top: 1px solid var(--cobalt); */
					}

					ul {
						list-style: none;
						padding: 0;
						display: flex;
						flex-direction: column;
						flex-wrap: wrap;
						gap: 20px;
						margin: 24px 0;

						@media (max-width: $mobile-xl) {
							display: grid;
							grid-template-columns: 1fr;
							margin: 16px 0;
							gap: 16px;
						}

						li {
							a {
								padding: 0;
								border-right: 0;
								border: none;
								position: relative;
								display: flex;
								align-items: center;
								gap: 12px;
								font: normal normal 300 12px/16px var(--primary-font-family);
								color: var(--fpe-blue);
								text-decoration: none;

								&:hover {
									text-decoration: underline;
								}
							}
						}
					}
				}

				&.four {
					grid-column: span 3;

					@media (max-width: $mobile-xl) {
						grid-column: span 4;
						padding: 0;
						justify-content: flex-start;
						flex-direction: column;
						grid-template-columns: 1fr;
						padding-top: 0;
						padding-bottom: 0 !important;
						order: 2;
						display: flex;
						flex-direction: column;
						gap: 24px;
						/* border-top: 1px solid var(--cobalt); */
					}
				}

				.aoc {
					display: flex;
					gap: 75px;
					color: var(--fpe-blue);
					padding-right: 36px;

					&::v-deep {
						font: normal normal 300 12px/16px var(--primary-font-family);

						p {
							font: normal normal 300 12px/16px var(--primary-font-family);
							color: var(--fpe-blue);
							margin: 0;
						}
					}
				}

				.contact_location {
					&::v-deep {
						display: flex;
						flex-direction: column;
						gap: 16px;

						p {
							font: normal normal 300 12px/16px var(--primary-font-family);
							color: var(--fpe-blue);
							margin: 0;
						}

						a {
							font: normal normal 300 12px/16px var(--primary-font-family);
							color: var(--fpe-blue);
							text-decoration: none;

							&:hover {
								text-decoration: underline;
							}
						}
					}
				}

				.copyright {
					&::v-deep {
						font: normal normal 300 12px/16px var(--primary-font-family);

						p {
							font: normal normal 300 12px/16px var(--primary-font-family);
							color: var(--fpe-blue);
						}
					}
				}

				ul.socials {
					list-style: none;
					padding: 0;
					display: flex;
					flex-direction: row;
					gap: 16px;
					justify-content: flex-start;
					align-items: center;
					margin-top: 24px;

					@media (max-width: $mobile-xl) {
						margin-top: 0;
						/* justify-content: center; */
					}

					li {
						a {
							display: flex;
						}
					}
				}
			}
		}
	}

	.footer_bottom {
		padding: 32px 0 0;
		display: flex;
		justify-content: center;
		align-items: center;

		.inner {
			grid-column: span 12;
			display: flex;
			justify-content: center;
			align-items: center;
			gap: 16px;

			@media (max-width: $mobile-xl) {
				grid-template-columns: repeat(4, 1fr);
				grid-column: span 4;
			}
		}

		a {
			font: normal normal 300 12px/16px var(--primary-font-family);
			color: #c7c7c7;
			text-decoration: none;
		}
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/SiteFooter.vue